module.exports = __webpack_public_path__ + "static/media/icon_close.1c7734c9.svg";